<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box">
                        <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Commission</span>
                            <span class="info-box-number">
                            10
                            <small>%</small>
                            </span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-danger elevation-1"><i class="fas fa-thumbs-up"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Likes</span>
                            <span class="info-box-number">41,410</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->

                <!-- fix for small devices only -->
                <div class="clearfix hidden-md-up"></div>

                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-success elevation-1"><i class="fas fa-shopping-cart"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Orders Received</span>
                            <span class="info-box-number">760</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-users"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Total Sales</span>
                            <span class="info-box-number">2,000</span>
                        </div>
                    <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
            <!-- /.col -->
            </div>
            <!-- /.row -->

            <div class="row">
                <!-- Left col -->
                <div class="col-md-12">
                    <!-- MAP & BOX PANE -->
                    <div class="card">
                    <div class="card-header p-1">
                        <div class="row">
                            <div class="col-md-2">
                                <h3 class="card-title">Paid Invoices</h3> <br />
                                <span id="curr_sale_rep">User</span>
                                <span id="pp_start_date" v-for="data in dataMX.data">{{ dataMX.pp_start_date }}</span>
                            </div>
                            <div class="col-md-8">
                                <h5>KPI Reached</h5>
                            </div>
                            <div class="col-md-2">                                                      
                                Lock button
                            </div>
                        </div>
                        <!-- <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div> -->
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <div class="">
                            <table class="table table-striped table-bordered nowrap" id="sales-selectors">
                                <thead>
                                    <tr>
                                        <th rowspan="2">Sale Rep</th>
                                        <th rowspan="2">Total Sale, $</th>                                                                      
                                        <th rowspan="2">Total Refund, $</th>
                                        
                                        <th colspan="3">Grades Bonuses</th>
                                        <th colspan="3">Sales Bonuses</th>
                                        
                                        <th rowspan="2">Extra Time</th>                                                                                                                                             
                                        <th rowspan="2">Earnings, $</th>
                                        
                                    </tr>
                                    <tr>
                                        <th>1st Call</th>
                                        <th>P1 Non Sex</th>
                                        <th>P2 Sales</th>
                                        
                                        <th>Total Sales</th>
                                        <th>Services Sold</th>
                                        <th>Upgrades Sold</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in dataMX.data.users_totals" >
                                        <td class='cm-user'>{{ data.user_name }}</td>                                                                              
                                        <td class='text-right'>{{ data.total_sale }}</td>
                                        <td class='text-right'>{{ data.total_refund }}</td>
                                        <td class='text-center'>{{ data.kpi_1 }}</td>
                                        <td class='text-center'>{{ data.kpi_2 }}</td>
                                        <td class='text-center'>{{ data.kpi_3 }}</td>
                                        <td class='text-center'>{{ data.total_sale_bonus }}</td>
                                        <td class='text-center'>{{ data.total_orders }}</td>
                                        <td class='text-center'>{{ data.total_upgrades }}</td>
                                        <td class='text-center'></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                <!-- /.card-body -->
                </div>
                <!-- /.card -->
                <!-- /.card -->
            </div>
            <!-- /.col -->
            </div>
            <!-- /.row -->
        </div><!--/. container-fluid -->
    </section>
</template>

<script>
    import 'datatables.net-dt';
    import 'datatables.net-buttons-dt';
    import 'datatables.net-responsive-dt';
    import 'datatables.net-buttons/js/buttons.html5.js'
    import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'

    export default {
        data () {
            return {
                dataMX: {}
            }
        },
        mounted() {
            console.log('MS Sales Dashboard Component mounted.');
            
            this.getPayPeriod();

            $('#sales-selectors').DataTable({
                dom: 'Bfrtip',
                responsive: true,
                lengthMenu: [
                     [-1, 50, 25, 10],
                     ['Show all', '50 rows',  '25 rows', '10 rows' ]
                 ],
               
                "order": [
                    [1, "desc"]
                ], 
                
                buttons: [
                    {extend:'pageLength'},
                    {
                        extend: 'copyHtml5',
                        exportOptions: {
                            columns: [0, ':visible']
                        }
                    },      
                ]
            });          
        },
        methods: {
            getPayPeriod() {
                axios.get('/api/v1/sales').then(({ data }) => (this.dataMX = data.data));
            }
        },
        created() {
            
        }
    }
</script>
